export default __webpack_public_path__ + "static/DEIPage-pattern-large-neutral-9ea52f9e7c7c3989e2775f49235709ce.png";